import script from "./tutorOnboardingFourthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingFourthPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingFourthPage.vue?vue&type=style&index=0&id=313c3da6&scoped=true&lang=css"
import "./tutorOnboardingFourthPage.vue?vue&type=style&index=1&id=313c3da6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313c3da6"]])

export default __exports__